import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { PagedResponse } from '@app/components/generic/generic'
import { ArchiveDocumentsService } from '@app/generated/api/archive-documents/archive-documents.service'
import type { ArchiveDocumentsGetAuditLogListParams } from '@app/generated/api/model'

import { AuditLogEntry } from './audit-log'

@Injectable({ providedIn: 'root' })
export class HistoryApi {
  private readonly archiveDocumentsService = inject(ArchiveDocumentsService)

  list (params: any): Observable<PagedResponse<AuditLogEntry>> {
    // HistoryApi's only caller today is archive-documents' history dialog; the code identifies the object.
    const code = params.code
    delete params.code
    return this.archiveDocumentsService.getAuditLog(code, params as ArchiveDocumentsGetAuditLogListParams) as unknown as Observable<PagedResponse<AuditLogEntry>>
  }
}
